import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import FreedomButton1 from '../FreedomButton1/FreedomButton1';
import { CheckCircleOutline } from '@mui/icons-material';
import FreedomFollowUpIcon from '../FreedomFollowUpIcon/FreedomFollowUpIcon';
import { ColorModeContext } from '../../../store';
import { useContext } from 'react';
import { appInsights } from '../../../auth/appInsight';
import { FixedAfterTwoDigit1, getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';
import { images, upgradeAccount, voucherSvg } from '../../../url/SvgLinks';
import SvgBackground from './components/ExclusiveToVip';

const gold = images.gold;
const platinum = images.platinum;

const darkgold = voucherSvg.darkgold;
const lightsilver = voucherSvg.lightsilver;
const darksilver = voucherSvg.darksilver;
const lightgold = voucherSvg.lightgold;
const lightplatinum = voucherSvg.lightplatinum;
const darkplatinum = voucherSvg.darkplatinum;
const lightsilvertogold = voucherSvg.lightsilvertogold;
const darksilvertogold = voucherSvg.darksilvertogold;
const lightsilvertoplatinum = voucherSvg.lightsilvertoplatinum;
const darksilvertoplatinum = voucherSvg.darksilvertoplatinum;
const lightgoldtoplatinum = voucherSvg.lightgoldtoplatinum;
const darkgoldtoplatinum = voucherSvg.darkgoldtoplatinum;
const exclusivevoucherdark = voucherSvg.exclusivevoucherdark;
const exclusivevoucherlight = voucherSvg.exclusivevoucherlight;

const vipvoucherdark = voucherSvg.vipvoucherdark;
const vipvoucherlight = voucherSvg.vipvoucherlight;
const exclusivetovipvoucherdark = voucherSvg.exclusivetovipvoucherdark;
const exclusivetovipvoucherlight = voucherSvg.exclusivetovipvoucherlight;

const silver = images.silver;
const exclusive = upgradeAccount.ExclusiveAccountTypeIcon;
const vip = upgradeAccount.VipAccountTypeIcon;
const voucherCards = (title, mode) => {
  return title === 'Silver'
    ? mode === 'light'
      ? `url(${lightsilver})`
      : `url(${darksilver})`
    : title === 'Gold'
    ? mode === 'light'
      ? `url(${lightgold})`
      : `url(${darkgold})`
    : title === 'Platinum'
    ? mode === 'light'
      ? `url(${lightplatinum})`
      : `url(${darkplatinum})`
    : title === 'Silver To Gold'
    ? mode === 'light'
      ? `url(${lightsilvertogold})`
      : `url(${darksilvertogold})`
    : title === 'Silver To Platinum'
    ? mode === 'light'
      ? `url(${lightsilvertoplatinum})`
      : `url(${darksilvertoplatinum})`
    : title === 'Gold To Platinum'
    ? mode === 'light'
      ? `url(${lightgoldtoplatinum})`
      : `url(${darkgoldtoplatinum})`
    : title === 'Exclusive'
    ? mode === 'light'
      ? `url(${exclusivevoucherlight})`
      : `url(${exclusivevoucherdark})`
    : title === 'VIP'
    ? mode === 'light'
      ? `url(${vipvoucherlight})`
      : `url(${vipvoucherdark})`
    : title === 'Exclusive To VIP'
    ? mode === 'light'
      ? `url(${exclusivetovipvoucherlight})`
      : `url(${exclusivetovipvoucherdark})`
    : '';
};

const VoucherWrapper = styled(Box)(({ theme, mode, title, ischecked, background, bordercolor }) => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  padding: '12px 10px 17px 10px',
  backgroundImage: voucherCards(title, mode),
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',

  borderRadius: '10px',
  [theme.breakpoints.up('xll')]: {
    padding: getStringProduct(1.25, '12px 10px 17px 10px'),
    borderRadius: getStringProduct(1.25, '10px')
  },
  [theme.breakpoints.up('xlll')]: {
    padding: getStringProduct(1.66, '12px 10px 17px 10px'),
    borderRadius: getStringProduct(1.66, '10px')
  },
  [theme.breakpoints.up('xl4')]: {
    padding: getStringProduct(2.46, '12px 10px 17px 10px'),
    borderRadius: getStringProduct(2.46, '10px')
  }
}));

const borderStyle = (title, mode, theme) => {
  return title === 'Silver'
    ? mode === 'light'
      ? '2px solid #B1B1B1'
      : '2px solid #505050'
    : title === 'Gold'
    ? mode === 'light'
      ? '2px solid #CFA632'
      : '2px solid #D0A935'
    : title === 'Platinum'
    ? mode === 'light'
      ? '2px solid #5DA899'
      : '2px solid #5DA899'
    : title === 'Silver To Gold'
    ? mode === 'light'
      ? '2px solid #D5BF82'
      : '2px solid #C1AC70'
    : title === 'Silver To Platinum'
    ? mode === 'light'
      ? '2px solid #B1B1B1'
      : '2px solid #B1B1B1'
    : title === 'Gold To Platinum'
    ? mode === 'light'
      ? '2px solid #C1AC70'
      : '2px solid #C1AC70'
    : title === 'Exclusive'
    ? mode === 'light'
      ? `2px solid ${theme.palette.primary.exclusivebgbutton}`
      : `2px solid ${theme.palette.primary.exclusivebgbutton}`
    : title === 'VIP'
    ? mode === 'light'
      ? `2px solid ${theme.palette.primary.vipbgbutton}`
      : `2px solid ${theme.palette.primary.vipbgbutton}`
    : title === 'Exclusive To VIP'
    ? mode === 'light'
      ? `2px solid ${theme.palette.primary.exclusivebgbutton}`
      : `2px solid ${theme.palette.primary.exclusivebgbutton}`
    : '';
};

const UpCircle = styled('div')(({ theme, ischecked, title, mode }) => ({
  position: 'absolute',
  left: '60%',
  top: '-15px',
  width: '28px',
  height: '28px',
  borderRadius: ' 50%',
  border: borderStyle(title, mode, theme),
  borderTopColor: 'transparent',
  borderLeftColor: 'transparent',
  transform: 'rotate(45deg)',
  // background: theme.palette.mode === 'light' ? `linear-gradient(180deg, ${theme.palette.background.wrappereBottom} 0%, ${theme.palette.background.wrapperbgTop} 100%)` : theme.palette.background.default,
  background: theme.palette.mode === 'light' ? theme.palette.background.default : theme.palette.background.default,
  [theme.breakpoints.up('xll')]: {
    top: getStringProduct(1.25, '-15px'),
    width: getStringProduct(1.25, '28px'),
    height: getStringProduct(1.25, '28px')
  },
  [theme.breakpoints.up('xlll')]: {
    top: getStringProduct(1.66, '-15px'),
    width: getStringProduct(1.66, '28px'),
    height: getStringProduct(1.66, '28px')
  },
  [theme.breakpoints.up('xl4')]: {
    top: getStringProduct(3, '-15px'),
    width: getStringProduct(3, '28px'),
    height: getStringProduct(3, '28px')
  }
}));

const DownCircle = styled('div')(({ theme, ischecked, title, mode }) => ({
  position: 'absolute',
  left: '60%',
  bottom: '-14.9px',
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  // border: `1px solid ${
  //   ischecked ? theme.palette.primary.textcolor : theme.palette.primary.main
  // }`,
  border: `${
    title === 'Silver'
      ? mode === 'light'
        ? '2px solid #B1B1B1'
        : '2px solid #505050'
      : title === 'Gold'
      ? mode === 'light'
        ? '2px solid #CEA631'
        : '2px solid #CEA631'
      : title === 'Platinum'
      ? mode === 'light'
        ? '2px solid #5DA899'
        : '2px solid #5DA899'
      : title === 'Silver To Gold'
      ? mode === 'light'
        ? '2px solid #D5B762'
        : '2px solid #CAAD57'
      : title === 'Silver To Platinum'
      ? mode === 'light'
        ? '2px solid #5DA899'
        : '2px solid #5DA899'
      : title === 'Gold To Platinum'
      ? mode === 'light'
        ? '2px solid #5DA899'
        : '2px solid #5DA899'
      : title === 'Exclusive'
      ? mode === 'light'
        ? `2px solid ${theme.palette.primary.exclusivebgbutton}`
        : `2px solid ${theme.palette.primary.exclusivebgbutton}`
      : title === 'VIP'
      ? mode === 'light'
        ? `2px solid ${theme.palette.primary.vipbgbutton}`
        : `2px solid ${theme.palette.primary.vipbgbutton}`
      : title === 'Exclusive To VIP'
      ? mode === 'light'
        ? `2px solid ${theme.palette.primary.vipbgbutton}`
        : `2px solid ${theme.palette.primary.vipbgbutton}`
      : ''
  }`,
  borderTopColor: 'transparent',
  borderLeftColor: 'transparent',
  transform: 'rotate(225deg)',
  // background: theme.palette.mode === 'light' ? `linear-gradient(180deg, ${theme.palette.background.wrappereBottom} 0%, ${theme.palette.background.wrapperbgTop} 100%)` : theme.palette.background.default,
  background: theme.palette.mode === 'light' ? theme.palette.background.default : theme.palette.background.default,
  [theme.breakpoints.up('xll')]: {
    bottom: getStringProduct(1.25, '-14.9px'),
    width: getStringProduct(1.25, '28px'),
    height: getStringProduct(1.25, '28px')
  },
  [theme.breakpoints.up('xlll')]: {
    bottom: getStringProduct(1.66, '-14.9px'),
    width: getStringProduct(1.66, '28px'),
    height: getStringProduct(1.66, '28px')
  },
  [theme.breakpoints.up('xl4')]: {
    bottom: getStringProduct(2.46, '-14.9px'),
    width: getStringProduct(2.46, '28px'),
    height: getStringProduct(2.46, '28px')
  }
}));
const DottedLines = styled('div')(({ theme, title, mode }) => ({
  position: 'absolute',
  left: '63%',
  top: '15px',
  width: '1.5px',
  height: '80%',
  backgroundImage:
    title === 'Silver'
      ? mode === 'light'
        ? 'linear-gradient(to bottom, #626262 60%, transparent 40%)'
        : 'linear-gradient(to bottom, #FFFFFF 60%, transparent 40%)'
      : title === 'Platinum'
      ? mode === 'light'
        ? 'linear-gradient(to bottom, #5DA899 60%, transparent 40%)'
        : 'linear-gradient(to bottom, #5DA899 60%, transparent 40%)'
      : title === 'Exclusive'
      ? `linear-gradient(to bottom, ${theme.palette.primary.exclusivebgbutton} 60%, transparent 40%)`
      : title === 'Exclusive To VIP'
      ? `linear-gradient(to bottom, ${theme.palette.primary.exclusivebgbutton} 60%, transparent 40%)`
      : title === 'Silver To Platinum'
      ? `linear-gradient(to bottom, #5DA899 60%, transparent 40%)`
      : title === 'Gold To Platinum'
      ? `linear-gradient(to bottom, #5DA899 60%, transparent 40%)`
      : title === 'VIP'
      ? `linear-gradient(to bottom, ${theme.palette.primary.vipbgbutton} 60%, transparent 40%)`
      : 'linear-gradient(to bottom, #ECC44F 60%, transparent 40%)',
  backgroundPosition: 'center',
  backgroundRepeat: 'repeat-y',
  backgroundSize: '6px 20px',
  [theme.breakpoints.up('xll')]: {
    // left: getStringProduct(1.25, '200px'),
    top: getStringProduct(1.25, '15px'),
    width: getStringProduct(1.25, '1.5px'),
    // height: getStringProduct(1.25, '80%'),
    backgroundSize: getStringProduct(1.25, '6px 20px')
  },
  [theme.breakpoints.up('xlll')]: {
    // left: getStringProduct(1.66, '200px'),
    top: getStringProduct(1.66, '15px'),
    width: getStringProduct(1.66, '1.5px'),
    // height: getStringProduct(1.66, '130px'),
    backgroundSize: getStringProduct(1.66, '6px 20px')
  },
  [theme.breakpoints.up('xl4')]: {
    // left: getStringProduct(2.46, '200px'),
    top: getStringProduct(2.46, '15px'),
    width: getStringProduct(2.46, '1.5px'),
    // height: getStringProduct(2.46, '130px'),
    backgroundSize: getStringProduct(2.46, '6px 20px')
  }
}));

const VoucherTitle = styled('div')(({ theme }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '16px',
  // lineHeight: '30px',
  color: theme.palette.primary.onBoardTextColor,
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '16px')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '16px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '16px')
  }
}));
const VoucherPrice = styled('div')(({ theme, fontsize = '16px' }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: fontsize || '32px',
  lineHeight: '30px',
  textAlign: 'right',
  color: theme.palette.primary.onBoardTextColor,
  [theme.breakpoints.only('xll')]: {
    fontSize: getStringProduct(1.25, fontsize || '32px'),
    lineHeight: getStringProduct(1.25, '30px')
  },
  [theme.breakpoints.only('xlll')]: {
    fontSize: getStringProduct(1.66, fontsize || '32px'),
    lineHeight: getStringProduct(1.66, '30px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, fontsize || '32px'),
    lineHeight: getStringProduct(2.46, '30px')
  }
}));

const VoucherDescription = styled('div')(({ theme, ischecked }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '12.5px',
  lineHeight: '20px',
  color: theme.palette.primary.onBoardTextColor,
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '12.5px'),
    lineHeight: getStringProduct(1.25, '20px')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '12.5px'),
    lineHeight: getStringProduct(1.66, '20px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '12.5px'),
    lineHeight: getStringProduct(2.46, '20px')
  }
}));

const ExpiryDateText = styled('div')(({ theme }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '12.5px',
  lineHeight: '18px',
  textAlign: 'right',
  color: theme.palette.primary.onBoardTextColor,
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '12.5px'),
    lineHeight: getStringProduct(1.25, '18px')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '12.5px'),
    lineHeight: getStringProduct(1.66, '18px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '12.5px'),
    lineHeight: getStringProduct(2.46, '18px')
  }
}));

const CardBorder = styled('div')(({ theme, title, mode }) => ({
  border:
    title === 'Silver'
      ? mode === 'light'
        ? '2px solid #B1B1B1'
        : '2px solid #505050'
      : title === 'Gold'
      ? mode === 'light'
        ? '2px solid #CEA631'
        : '2px solid #CEA631'
      : title === 'Platinum'
      ? mode === 'light'
        ? '2px solid #5DA899'
        : '2px solid #5DA899'
      : title === 'Exclusive'
      ? mode === 'light'
        ? `2px solid ${theme.palette.primary.exclusivebgbutton}`
        : `2px solid ${theme.palette.primary.exclusivebgbutton}`
      : title === 'VIP'
      ? mode === 'light'
        ? `2px solid ${theme.palette.primary.vipbgbutton}`
        : `2px solid ${theme.palette.primary.vipbgbutton}`
      : '' /* set the border width and make it transparent  theme.palette.primary.exclusivebgbutton*/,
  background:
    title === 'Silver To Gold'
      ? mode === 'light'
        ? 'linear-gradient(-40deg, #CEA631, #DCDCDC)'
        : 'linear-gradient(-40deg, #CEA631, #B1B1B1)'
      : title === 'Silver To Platinum'
      ? mode === 'light'
        ? 'linear-gradient(-40deg, #5DA899, #C8C8C8)'
        : 'linear-gradient(-40deg, #5DA899, #FFFFFF)'
      : title === 'Gold To Platinum'
      ? mode === 'light'
        ? 'linear-gradient(-40deg, #5DA899, #CEA631)'
        : 'linear-gradient(-40deg, #5DA899, #CEA631)'
      : title === 'Exclusive To VIP'
      ? mode === 'light'
        ? `linear-gradient(-40deg, ${theme.palette.primary.vipbgbutton}, ${theme.palette.primary.exclusivebgbutton})`
        : `linear-gradient(-40deg, ${theme.palette.primary.vipbgbutton}, ${theme.palette.primary.exclusivebgbutton})`
      : '' /* set the border gradient */,
  // background: 'linear-gradient(-40deg, #CEA631, #DCDCDC)',
  borderImageSlice: 1 /* set the border image slice to 1 */,
  padding: title === 'Silver' || title === 'Gold' || title === 'Platinum' ? '0px' : '1px' /* add some padding to the div */,
  borderRadius: '10px',
  width: `${400}px`,
  height: `${200}px`,
  [theme.breakpoints.up('xll')]: {
    border:
      title === 'Silver'
        ? mode === 'light'
          ? getDynamicBorder(1.25, '2px solid #B1B1B1')
          : getDynamicBorder(1.25, '2px solid #505050')
        : title === 'Gold'
        ? mode === 'light'
          ? getDynamicBorder(1.25, '2px solid #CEA631')
          : getDynamicBorder(1.25, '2px solid #CEA631')
        : title === 'Platinum'
        ? mode === 'light'
          ? getDynamicBorder(1.25, '2px solid #5DA899')
          : getDynamicBorder(1.25, '2px solid #5DA899')
        : title === 'Exclusive'
        ? mode === 'light'
          ? getDynamicBorder(1.25, `2px solid ${theme.palette.primary.exclusivebgbutton}`)
          : getDynamicBorder(1.25, `2px solid ${theme.palette.primary.exclusivebgbutton}`)
        : title === 'VIP'
        ? mode === 'light'
          ? getDynamicBorder(1.25, `2px solid ${theme.palette.primary.vipbgbutton}`)
          : getDynamicBorder(1.25, `2px solid ${theme.palette.primary.vipbgbutton}`)
        : '' /* set the border width and make it transparent  theme.palette.primary.exclusivebgbutton*/,

    padding: title === 'Silver' || title === 'Gold' || title === 'Platinum' ? '0px' : getStringProduct(1.25, '1px') /* add some padding to the div */,
    borderRadius: getStringProduct(1.25, '10px'),
    width: getStringProduct(1.25, `${400}px`),
    height: getStringProduct(1.25, `${200}px`)
  },
  [theme.breakpoints.up('xlll')]: {
    border:
      title === 'Silver'
        ? mode === 'light'
          ? getDynamicBorder(1.66, '2px solid #B1B1B1')
          : getDynamicBorder(1.66, '2px solid #505050')
        : title === 'Gold'
        ? mode === 'light'
          ? getDynamicBorder(1.66, '2px solid #CEA631')
          : getDynamicBorder(1.66, '2px solid #CEA631')
        : title === 'Platinum'
        ? mode === 'light'
          ? getDynamicBorder(1.66, '2px solid #5DA899')
          : getDynamicBorder(1.66, '2px solid #5DA899')
        : title === 'Exclusive'
        ? mode === 'light'
          ? getDynamicBorder(1.66, `2px solid ${theme.palette.primary.exclusivebgbutton}`)
          : getDynamicBorder(1.66, `2px solid ${theme.palette.primary.exclusivebgbutton}`)
        : title === 'VIP'
        ? mode === 'light'
          ? getDynamicBorder(1.66, `2px solid ${theme.palette.primary.vipbgbutton}`)
          : getDynamicBorder(1.66, `2px solid ${theme.palette.primary.vipbgbutton}`)
        : '' /* set the border width and make it transparent  theme.palette.primary.exclusivebgbutton*/,

    padding: title === 'Silver' || title === 'Gold' || title === 'Platinum' ? '0px' : getStringProduct(1.66, '1px') /* add some padding to the div */,
    borderRadius: getStringProduct(1.66, '10px'),
    width: getStringProduct(1.66, `${400}px`),
    height: getStringProduct(1.66, `${200}px`)
  },
  [theme.breakpoints.up('xl4')]: {
    border:
      title === 'Silver'
        ? mode === 'light'
          ? getDynamicBorder(2.46, '2px solid #B1B1B1')
          : getDynamicBorder(2.46, '2px solid #505050')
        : title === 'Gold'
        ? mode === 'light'
          ? getDynamicBorder(2.46, '2px solid #CEA631')
          : getDynamicBorder(2.46, '2px solid #CEA631')
        : title === 'Platinum'
        ? mode === 'light'
          ? getDynamicBorder(2.46, '2px solid #5DA899')
          : getDynamicBorder(2.46, '2px solid #5DA899')
        : title === 'Exclusive'
        ? mode === 'light'
          ? getDynamicBorder(2.46, `2px solid ${theme.palette.primary.exclusivebgbutton}`)
          : getDynamicBorder(2.46, `2px solid ${theme.palette.primary.exclusivebgbutton}`)
        : title === 'VIP'
        ? mode === 'light'
          ? getDynamicBorder(2.46, `2px solid ${theme.palette.primary.vipbgbutton}`)
          : getDynamicBorder(2.46, `2px solid ${theme.palette.primary.vipbgbutton}`)
        : '' /* set the border width and make it transparent  theme.palette.primary.exclusivebgbutton*/,

    padding: title === 'Silver' || title === 'Gold' || title === 'Platinum' ? '0px' : getStringProduct(2.46, '1px') /* add some padding to the div */,
    borderRadius: getStringProduct(2.46, '10px'),
    width: getStringProduct(2.46, `${400}px`),
    height: getStringProduct(2.46, `${200}px`)
  }
}));

const ExpiryDate = styled('div')(({ theme }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '12.5px',
  lineHeight: '18px',
  textAlign: 'right',
  color: theme.palette.primary.onBoardTextColor,
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '12.5px'),
    lineHeight: getStringProduct(1.25, '18px')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '12.5px'),
    lineHeight: getStringProduct(1.66, '18px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '12.5px'),
    lineHeight: getStringProduct(2.46, '18px')
  }
}));

const FreedomVoucherCard = (props) => {
  const { bordercolor, ischecked, description, title, price, expirydate, clickOnCard, id } = props;
  //  debugger
  const {
    colorMode: { mode }
  } = useContext(ColorModeContext);
  const theme = useTheme();
  const { t } = useTranslation();
  const xl4 = useMediaQuery(theme.breakpoints.up('xl4'));
  const xlll = useMediaQuery(theme.breakpoints.up('xlll'));
  const xll = useMediaQuery(theme.breakpoints.up('xll'));
  try {
    return (
      // <SvgBackground>
      <CardBorder title={title} mode={mode}>
        <VoucherWrapper mode={mode} title={title}>
          <UpCircle {...props} title={title} mode={mode} />
          <DownCircle {...props} title={title} mode={mode} />
          <DottedLines title={title} mode={mode} />
          <Grid container justifyContent={'space-between'} height={'100%'} padding={'5px'}>
            <Grid item xs={7} sm={7} md={7} lg={7}>
              <Grid item container spacing={xl4 ? 2*2.46 : xlll ? 2* 1.66 : xll ? 1.25*2 : 2}>
                {/* {title === "Silver" ||
                  title === "Gold" ||
                  title === "Platinum" ? (
                  <> */}
                <Grid item>
                  <Box
                    display={'flex'}
                    gap={'10px'}
                    alignItems={'center'}
                    // mt={mobile360 ? 1 : xllScreen ? 0 : 1}
                    sx={{
                      [theme.breakpoints.up('xll')]: {
                        gap: getStringProduct(1.25, '10px')
                      },
                      [theme.breakpoints.up('xlll')]: {
                        gap: getStringProduct(1.66, '10px')
                      },
                      [theme.breakpoints.up('xl4')]: {
                        gap: getStringProduct(2.46, '10px')
                      },
                    }}
                  >
                    {/* <Box> */}
                    <FreedomFollowUpIcon
                      disabled
                      padding="2px"
                      borderradius="6.10748px"
                      backgroundcolor={theme.palette.primary.default}
                      bordercolor={theme.palette.border.containerborder}
                      backgroundhovercolor={theme.palette.primary.white}
                      imageheight={'18px'}
                      imagewidth={'18px'}
                      iconimg={
                        title === 'Silver'
                          ? silver
                          : title === 'Gold'
                          ? gold
                          : title === 'Platinum'
                          ? platinum
                          : title === 'Silver To Gold'
                          ? gold
                          : title === 'Silver To Platinum'
                          ? platinum
                          : title === 'Gold To Platinum'
                          ? platinum
                          : title === 'Exclusive'
                          ? exclusive
                          : title === 'VIP'
                          ? vip
                          : title === 'Exclusive To VIP'
                          ? vip
                          : ''
                      }
                      width={'23.21px'}
                      height={'23.82px'}
                      responsiveheight={'20.18px'}
                      responsivewidth={'20.71x'}
                      responsiveborderrad={'5.31085px'}
                    />
                    <VoucherTitle>{title}</VoucherTitle>
                  </Box>
                </Grid>
                <Grid item>
                  <VoucherDescription {...props}>{description}</VoucherDescription>
                </Grid>
              </Grid>
            </Grid>
            <Grid item container xs={4} sm={4} md={4} lg={4} justifyContent={'right'} spacing={xl4 ? 2.46 * 1.75 : xlll ? 1.66 * 1.75 : xll ? 1.25 * 1.75 : 1.75}>
              <Grid item xs={12}>
                <VoucherPrice fontsize="20px">${FixedAfterTwoDigit1(+price)}</VoucherPrice>
              </Grid>
              <Grid item xs={12}>
                <Box>
                  <ExpiryDateText>
                    {/* Expiry Date */}
                    Validity:
                  </ExpiryDateText>
                  <ExpiryDate>{expirydate}</ExpiryDate>
                </Box>
              </Grid>
              {ischecked ? (
                <Grid container item xs={12} sm={12} md={12} justifyContent={'flex-end'}>
                  <FreedomButton1
                    btnbackground={
                      title === 'Silver'
                        ? theme.palette.button.vouchersilverbtncolor
                        : title === 'Gold'
                        ? theme.palette.button.vouchergoldbtncolor
                        : title === 'Platinum'
                        ? theme.palette.button.voucherplatinumbtncolor
                        : title === 'Silver To Gold'
                        ? theme.palette.button.vouchergoldbtncolor
                        : title === 'Silver To Platinum'
                        ? theme.palette.button.voucherplatinumbtncolor
                        : title === 'Gold To Platinum'
                        ? theme.palette.button.voucherplatinumbtncolor
                        : title === 'Exclusive'
                        ? theme.palette.primary.exclusivebgbutton
                        : title === 'VIP'
                        ? theme.palette.primary.vipbgbutton
                        : title === 'Exclusive To VIP'
                        ? theme.palette.primary.vipbgbutton
                        : ''
                    }
                    btncolor={theme.palette.primary.white}
                    btnhovercolor={
                      title === 'Silver'
                        ? theme.palette.button.vouchersilverbtncolor
                        : title === 'Gold'
                        ? theme.palette.button.vouchergoldbtncolor
                        : title === 'Platinum'
                        ? theme.palette.button.voucherplatinumbtncolor
                        : title === 'Silver To Gold'
                        ? theme.palette.button.vouchergoldbtncolor
                        : title === 'Silver To Platinum'
                        ? theme.palette.button.voucherplatinumbtncolor
                        : title === 'Gold To Platinum'
                        ? theme.palette.button.voucherplatinumbtncolor
                        : title === 'Exclusive'
                        ? theme.palette.primary.exclusivebgbutton
                        : title === 'VIP'
                        ? theme.palette.primary.vipbgbutton
                        : title === 'Exclusive To VIP'
                        ? theme.palette.primary.vipbgbutton
                        : ''
                    }
                    texthovercolor={'none'}
                    variant="contained"
                    height={'28.8px'}
                    width="90.4px"
                    fontsize={'12px'}
                    startIcon={<CheckCircleOutline />}
                    //  padding={"12px 16px"}
                    borderradius={'5px'}
                  >
                    {t('Selected')}
                  </FreedomButton1>
                </Grid>
              ) : (
                <Grid item container justifyContent={'flex-end'} xs={12} sm={12} md={10}>
                  <FreedomButton1
                    // sx={{  mr: -12 }}
                    btnbackground={theme.palette.primary.default}
                    btncolor={theme.palette.primary.onBoardTextColor}
                    btnhovercolor={'none'}
                    texthovercolor={theme.palette.primary.onBoardTextColor}
                    variant="contained"
                    height={'28.8px'}
                    width="90.4px"
                    borderradius={'5px'}
                    fontsize={'12px'}
                    onClick={() => {
                      clickOnCard(id, title, price, expirydate);
                    }}
                  >
                    {t('Select')}
                  </FreedomButton1>
                </Grid>
              )}
            </Grid>
          </Grid>
        </VoucherWrapper>
      </CardBorder>
      // </SvgBackground>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomVoucherCard;
